import { Component, Inject, Input, OnChanges, OnDestroy, OnInit, Optional, SimpleChanges } from '@angular/core';
import { Gantt } from '@app/core/components/gantt/gantt.model';
import { GanttOptions } from '@app/core/components/gantt/gantt.types';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { CustactGanttGet, CustactService, GetCustactGanttParams } from '@app/services/custact.service';

@Component({
    selector: 'tt-custact-gantt',
    standalone: false,
    templateUrl: './custact-gantt.component.html',
    styleUrls: ['./custact-gantt.component.css'],
})
export class CustactGanttComponent implements OnInit, OnChanges, OnDestroy {
    @Input()
    public params?: GetCustactGanttParams;

    public page?: CustactGanttGet;

    public gantt?: GanttOptions;

    private initialized = false;
    private destroyed = false;
    private loadVersion = 0;

    constructor(
        private custact: CustactService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public readGantt() {
        if (this.destroyed || !this.page) return;
        if (!this.gantt) {
            this.gantt = new Gantt().setRememberId('w_custactgantt.gantt').setLoadDataFunction({ method: 4069, parameters: () => this.page });
        } else {
            // this.gantt.api.read();
        }
    }

    private async init(): Promise<void> {
        const params = this.params;
        if (!params || this.destroyed) return;
        const version = ++this.loadVersion;
        const page = await this.custact.getCustactGantt(params);
        if (this.destroyed || version !== this.loadVersion) return;
        this.page = page;
        this.readGantt();
    }

    ngOnInit(): void {
        this.initialized = true;
        this.params ??= this.navigator?.params as GetCustactGanttParams | undefined;
        if (this.params) void this.init();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // Angular reports the initial input before ngOnInit. Load it only once.
        if (this.initialized && changes['params']) void this.init();
    }

    ngOnDestroy(): void {
        this.destroyed = true;
        this.loadVersion++;
    }
}
